import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, ValidationErrors, Validators} from '@angular/forms';
import * as moment from 'moment';
import {UsersInsuranceService} from '../../services/usersinsurance/users.insurance.service';
import {UsersService} from '../../services/users/users.service';
import {ToastComponent} from '../toast/toast.component';
import {UtilsService} from '../../services/utils/utils.service';
import {VendorsService} from '../../services/vendors/vendors.service';
import {CommissionJunctionService} from '../../services/commissionjunction/commissionjunction.service';

@Component({
  selector: 'app-insurance-primary',
  templateUrl: './insurance-primary.component.html',
  styleUrls: ['./insurance-primary.component.scss']
})
export class InsurancePrimaryComponent implements OnInit, OnChanges {

  @Input() vendorProduct;
  @Output() formEvent: EventEmitter <any> = new EventEmitter<any>();

  public maxDate = moment().toDate();
  protected primaryInfo: any;
  protected tobaccoDate = '';
  protected errorMessages = '';
  public form;
  public showTobaccoDate = false;

  constructor(
      private formBuilder: FormBuilder,
      private usersInsuranceService: UsersInsuranceService,
      private usersService: UsersService,
      private toastComponent: ToastComponent,
      private utilsService: UtilsService,
      private cjService: CommissionJunctionService,
      private vendorsService: VendorsService
  ) {
    this.form = this.formBuilder.group({
      gender: new FormControl('', Validators.required),
      tobaccoUseDate: new FormControl('')
    });
    this.form.valueChanges.subscribe((value) => {
      this.errorMessages = this.getFormValidationErrors(this.form);
    });
  }

  ngOnChanges(event): void {
    this.ngOnInit();
  }

  async loadVendorData() {
    const allVendorProducts = await this.vendorsService.getAllVendorProducts();
    const items = await this.cjService.productSearch('', '');
    const vendorsInTiles = items
        .map(item => item.buttons?.find(
            button => button.action.type === 'wallitStripe' || button.action.type === 'externalurl'
        )?.action.arguments.vendorProductId)
        .filter(Boolean); // removes undefined/null
    this.showTobaccoDate = allVendorProducts
        .filter(vp => vendorsInTiles.includes(vp.id))
        .some(vp => vp?.metadata?.enroll?.fields?.tobaccoUseDate);
  }

  async ngOnInit(): Promise<void> {
    this.formEvent.emit(this.form);
    await this.loadVendorData();
    this.usersInsuranceService.getInsurancePrimary(this.usersService.getCurrentUserId(), this.vendorProductId()).then(result => {
      if (result.id) {
        this.primaryInfo = result;
        this.resetClicked();
        setTimeout(() => {
          this.resetClicked();
        }, 500);
      }
    });
  }

  getFormValidationErrors(form) {
    const errorMessages = [];
    Object.keys(form.controls).forEach(key => {
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          if (controlErrors[keyError].message) {
            errorMessages.push(`${key}: ${controlErrors[keyError].message}`);
          }
        });
      }
    });
    return errorMessages.join(', ');
  }

  resetClicked(): void {
    this.form.reset();
    this.form.get('gender')?.setValue(this.primaryInfo?.gender);
    this.form.get('tobaccoUseDate')?.setValue(this.primaryInfo?.tobaccoUseDate);
    this.tobaccoDate = this.primaryInfo?.tobaccoUseDate;
  }

  removeTobaccoDate(): void {
    this.form.get('tobaccoUseDate')?.setValue('');
  }

  saveClicked(): void {
    const newInfo = {
      gender: this.form.get('gender')?.value,
      tobaccoUseDate: this.utilsService.convertDate(this.form.get('tobaccoUseDate')?.value)
    };
    if (this.primaryInfo && !this.primaryInfo.fromWallit) {
      this.usersInsuranceService.modifyInsurancePrimary(this.usersService.getCurrentUserId(), this.vendorProductId(), newInfo).then(_ => {
        this.usersInsuranceService.updateCarriers(this.usersService.getCurrentUserId());
        this.toastComponent.presentToast('User insurance primary info updated');
        this.resetClicked();
      });
    } else {
      this.usersInsuranceService.createInsurancePrimary(this.usersService.getCurrentUserId(), this.vendorProductId(), this.form.get('gender')?.value, {}, this.utilsService.convertDate(this.form.get('tobaccoUseDate')?.value)
      ).then(_ => {
        this.primaryInfo = newInfo;
        this.toastComponent.presentToast('User insurance primary info created');
        this.usersInsuranceService.usersInsuranceObservable.next(null);
        this.resetClicked();
      });
    }
  }

  vendorProductId() {
    // return this.vendorProduct?.id || 'wallit';
    return 'wallit';
  }

}
